<!--suppress HtmlUnknownTarget -->
<template>
    <main>
        <banner :title="getText('contacts')"/>
        <section class="bg-gray-700">
            <div class="container mx-auto px-4 pb-16 md:pb-48">
                <div class="flex flex-wrap">
                    <div class="w-full md:w-1/12 pt-16 hidden md:block"></div>
                    <div class="w-full md:w-3/12 pt-4 md:pt-16 text-center md:mr-16 px-16 md:px-0">
                        <img src="/images/mezulis-1.jpg" alt="Profile picture" class="profile h-auto"/>
                    </div>
                    <div class="w-full md:w-4/12 pt-4 md:pt-16">
                        <div class="block mb-4">
                            <h2 class="text-white font-semibold text-3xl">{{ this.getText('contacts-name') }}</h2>
                        </div>
                        <div class="block mb-4">
                            <span class="text-white font-semibold text-xl">{{ this.getText('contacts-number') }}: </span>
                            <a v-if="!isPhoneShown"
                               class="text-white font-semibold text-xl cursor-pointer"
                               style="text-decoration: underline"
                               @click="showPhone">
                                {{ this.getText('contacts-click') }}
                            </a>
                            <span v-if="isPhoneShown" class="inline-block text-white font-semibold text-xl">
                                +371 294 670 00
                            </span>
                        </div>
                        <div class="block mb-4">
                            <p class="text-white font-semibold text-xl mb-4">{{ this.getText('contacts-email') }}: marcis@arhetips.lv</p>
                        </div>
                        <div class="block mb-4">
                            <p class="text-white font-semibold text-xl mb-4">
                                {{ this.getText('contacts-office') }}:
                                <a :href="getMapsAddress()"
                                   target="_blank"
                                   rel="noopener noreferrer"
                                   style="text-decoration: underline">
                                    {{ this.getText('contacts-office-address') }}
                                </a>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </main>
</template>

<script>
    import {mapGetters} from 'vuex';
    import Banner from "./Banner";

    export default {
        name: "Contacts",
        components: {Banner},
        data() {
            return {
                isPhoneShown: false,
            }
        },
        methods: {
            showPhone() {
                this.isPhoneShown = true;
            },
            getMapsAddress() {
                return `https://maps.google.com/?q=${this.getText('contacts-office-address')}`;
            },
        },
        computed: {
            ...mapGetters(['getText'])
        },
    }
</script>